<div class="shared-container">
  <ng-container *ngIf="sucesso; else formObraContratada">
    <app-sucesso
      [mensagem]="'Obra contratada com sucesso!'"
      [botaoTexto]="'Continuar'"
      (continuar)="continuar()"
    ></app-sucesso>
  </ng-container>
  <ng-template #formObraContratada>
    <div class="form-content">
      <label for="taskDescription">Descreva a Tarefa</label>
      <textarea
        id="taskDescription"
        class="form-control"
        [(ngModel)]="taskDescription"
        placeholder="Descreva a tarefa..."
      ></textarea>

     <select
  id="responsavel"
  class="form-control custom-select"
  [(ngModel)]="responsavelSelecionado"
  (ngModelChange)="campoObrigatorioErro = false"
  [ngClass]="{
    'is-invalid': campoObrigatorioErro && !responsavelSelecionado
  }"
>

        <option value="">Selecione o responsável</option>
        <option *ngFor="let option of responsavel" [ngValue]="option.id">
          {{ option.name }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !responsavelSelecionado"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>
    </div>

    <div class="footer-actions">
      <button class="btn btn-secondary" type="button" (click)="clear()">
        Limpar Dados
      </button>
      <button
        class="btn btn-primary"
        type="button"
        (click)="atualizarObraContratada()"
      >
        Obra Contratada
      </button>
    </div>
  </ng-template>
</div>
